import styled from 'styled-components';

export const ReverseButtonStyle = styled.button<{ color?: string }>`
  all: unset;
  cursor: pointer;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  color: #999; /* default icon color */
  transition: background-color 0.2s ease, color 0.2s ease;

  &:hover {
    background-color: #e5e5e5;
  }
`;